import { Box } from '@mui/material'

type TImagePreviewProps = {
  url: string
  name: string
  onError: () => void
  isLoading: boolean
  variant: 'card' | 'chat'
}

export const ImagePreview = ({ url, name, onError, isLoading, variant }: TImagePreviewProps) => {
  const isChat = variant === 'chat'

  if (isChat) {
    return (
      <Box
        sx={{
          bgcolor: 'background.default',
          borderRadius: 1,
          px: 1.5,
          py: 0.5,
          fontSize: 14,
          boxShadow: 0,
          maxWidth: 600,
          mb: 1,
          opacity: isLoading ? 0.7 : 1,
        }}
      >
        <Box
          component="img"
          src={url}
          alt={name}
          onError={onError}
          sx={{
            maxWidth: '100%',
            maxHeight: 250,
            display: 'block',
            margin: '0 auto',
            borderRadius: 8,
          }}
        />
      </Box>
    )
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
      <Box
        component="img"
        src={url}
        alt={name}
        onError={onError}
        sx={{
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'contain',
        }}
      />
    </Box>
  )
}
